import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './SignUp.css';

const Signup = () => {
  const [formData, setFormData] = useState({
    name: '',
    user_name: '',
    phone_number: '',
    email: '',
    password: '',
    gender: 'Male',
    referral_code: '',
    pharmacy_name: '',
    pharmacy_address: '',
    city: '',
    country: '',
    latitude: '',
    longitude: ''
  });

  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const GOOGLE_API_KEY = 'AIzaSyCeUwEIjvESLIv_658RhDLYfleCqmsdtNs'; // Replace with your real key

  // Auto-fetch coordinates when address, city, and country are filled
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (formData.pharmacy_address.trim() && formData.city.trim() && formData.country.trim()) {
        const fullAddress = `${formData.pharmacy_address}, ${formData.city}, ${formData.country}`;
        console.log('📍 Fetching coordinates for:', fullAddress);

        try {
          const geo = await axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json`,
            {
              params: {
                address: fullAddress,
                key: GOOGLE_API_KEY,
              },
            }
          );

          console.log('📦 Full Geocoding response:', geo.data);

          const results = geo?.data?.results;
          if (geo?.data?.status !== 'OK') {
            console.error('🚫 Google Maps API Error:', geo.data.status);
          }

          if (results && results.length > 0) {
            const loc = results[0].geometry.location;
            setFormData((prev) => ({
              ...prev,
              latitude: loc.lat.toFixed(6),
              longitude: loc.lng.toFixed(6),
            }));
          } else {
            console.warn('⚠️ No coordinates found for this address.');
          }
        } catch (err) {
          console.error('❌ Geocoding failed:', err);
        }
      }
    }, 800);

    return () => clearTimeout(timeout);
  }, [formData.pharmacy_address, formData.city, formData.country]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setLoading(true);

    try {
      const payload = {
        ...formData,
        latitude: parseFloat(formData.latitude) || 0,
        longitude: parseFloat(formData.longitude) || 0
      };

      const res = await axios.post(
        'http://127.0.0.1:8000/users/pre-register/pharmacist/new/',
        payload,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
      );

      if (res?.data) {
        localStorage.setItem('pharmacy_email', formData.email);
        localStorage.setItem('pharmacy_phone_number', formData.phone_number);

        setSuccessMessage('Pharmacy signup successful! Redirecting to OTP verification...');
        setTimeout(() => navigate('/OtpVerification'), 2000);
      }
    } catch (err) {
      const errorDetail = err.response?.data?.detail;
      if (typeof errorDetail === 'string') {
        setError(errorDetail);
      } else if (Array.isArray(errorDetail)) {
        setError(errorDetail.map(e => e.msg).join(', '));
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="crypto-signup-container">
      <form className="crypto-signup-form" onSubmit={handleSubmit}>
        <h2>🏥 Register Your Pharmacy</h2>

        {error && <div className="crypto-error">{error}</div>}
        {successMessage && <div className="crypto-success">{successMessage}</div>}

        <input
          type="text"
          name="name"
          placeholder="Your Full Name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="user_name"
          placeholder="Username"
          value={formData.user_name}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="phone_number"
          placeholder="Phone Number"
          value={formData.phone_number}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <select name="gender" value={formData.gender} onChange={handleChange} required>
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>

        <input
          type="text"
          name="referral_code"
          placeholder="Referral Code (optional)"
          value={formData.referral_code}
          onChange={handleChange}
        />

        <input
          type="text"
          name="pharmacy_name"
          placeholder="Pharmacy Name"
          value={formData.pharmacy_name}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="pharmacy_address"
          placeholder="Pharmacy Street Address"
          value={formData.pharmacy_address}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="city"
          placeholder="City"
          value={formData.city}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="country"
          placeholder="Country"
          value={formData.country}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          name="latitude"
          placeholder="Latitude"
          value={formData.latitude}
          readOnly
        />

        <input
          type="number"
          name="longitude"
          placeholder="Longitude"
          value={formData.longitude}
          readOnly
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Registering...' : 'Register Pharmacy'}
        </button>

        <p>Already have an account? <Link to="/Login">Login</Link></p>
      </form>
    </div>
  );
};

export default Signup;
